import React from 'react';

interface PencilIconProps {
  className?: string;
  size?: number;
}

export const PencilIcon: React.FC<PencilIconProps> = ({ 
  className = "w-5 h-5", 
  size = 20 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Pencil body with natural tilt */}
      <path
        d="M17 3a2.85 2.85 0 0 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Pencil tip detail */}
      <path
        d="M15 5l4 4"
        strokeWidth="1"
        strokeLinecap="round"
        opacity="0.7"
      />
      {/* Subtle eraser hint */}
      <path
        d="M3 22l2-2"
        strokeWidth="1"
        strokeLinecap="round"
        opacity="0.5"
      />
    </svg>
  );
};

export default PencilIcon;
